export default __webpack_public_path__ + "static/media/codechef.9cd036da.jpg";